<script lang="ts" setup>
withDefaults(defineProps<{
  title?: string
  useShow?: boolean
  panelId?: string
}>(), {
  panelId: `${getCurrentInstance()?.uid}-expand-panel`,
})

const isOpen = defineModel({ default: false })

const slots = useSlots()
const isPreContentSlotInUse = computed(() => slots?.precontent?.({}))
</script>

<template>
  <ContentGroup>
    <template #title>
      <slot
        name="title"
        :toggle="() => isOpen = !isOpen"
        :is-open="isOpen"
      >
        <div
          class="group/toggled relative flex w-full flex-col gap-0.5"
        >
          <div
            class="flex w-full items-center justify-between gap-2"
          >
            <button
              class="grow text-left font-semibold"
              :aria-expanded="isOpen"
              :aria-controls="panelId"
              @click="isOpen = !isOpen"
            >
              {{ title }}
            </button>
            <slot
              name="toggle"
              :is-open="isOpen"
              :open="() => isOpen = true"
              :close="() => isOpen = false"
              :toggle="() => isOpen = !isOpen"
            >
              <DTCheck
                v-model="isOpen"
                check-class="group-hover/toggled:border-gray-800"
              />
            </slot>
          </div>
          <slot name="precontent" />

          <div
            v-if="isPreContentSlotInUse"
            class="absolute inset-0 cursor-pointer"
            @click="() => isOpen = !isOpen"
          />
        </div>
      </slot>
    </template>

    <div
      v-if="useShow"
      v-show="isOpen"
      :id="panelId"
    >
      <slot :open="isOpen" />
    </div>

    <div
      v-else-if="isOpen"
      :id="panelId"
    >
      <slot :open="isOpen" />
    </div>
  </ContentGroup>
</template>
